import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cn } from "@/lib/utils/cn";

/** Apple-style native toggle. */
export const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitive.Root
    ref={ref}
    className={cn(
      "peer inline-flex h-[28px] w-[48px] shrink-0 cursor-pointer items-center rounded-full border border-transparent transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=checked]:bg-success data-[state=unchecked]:bg-muted-foreground/30",
      className,
    )}
    {...props}
  >
    <SwitchPrimitive.Thumb
      className={cn(
        "pointer-events-none block h-[24px] w-[24px] rounded-full bg-white shadow-md ring-0 transition-transform duration-300",
        "data-[state=checked]:translate-x-[21px] data-[state=unchecked]:translate-x-[1px]",
      )}
    />
  </SwitchPrimitive.Root>
));
Switch.displayName = "Switch";
